/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetWorkingTimes200Response,
} from '../models/index';
import {
    GetWorkingTimes200ResponseFromJSON,
    GetWorkingTimes200ResponseToJSON,
} from '../models/index';

export interface UpdateWorkingTimesRequest {
    getWorkingTimes200Response: GetWorkingTimes200Response;
}

/**
 * 
 */
export class SchedulesApi extends runtime.BaseAPI {

    /**
     */
    async getWorkingTimesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetWorkingTimes200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/schedules/working-times`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetWorkingTimes200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getWorkingTimes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetWorkingTimes200Response> {
        const response = await this.getWorkingTimesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateWorkingTimesRaw(requestParameters: UpdateWorkingTimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getWorkingTimes200Response'] == null) {
            throw new runtime.RequiredError(
                'getWorkingTimes200Response',
                'Required parameter "getWorkingTimes200Response" was null or undefined when calling updateWorkingTimes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/schedules/working-times`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetWorkingTimes200ResponseToJSON(requestParameters['getWorkingTimes200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateWorkingTimes(requestParameters: UpdateWorkingTimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateWorkingTimesRaw(requestParameters, initOverrides);
    }

}
